import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import {
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Button,
} from '@material-ui/core'
import { injectIntl } from 'react-intl'
import { licenseeFetchList } from 'reducers/licensee/reducer'
import Psfs from 'lib/psfs/Psfs'
import { API_URL_LICENSEE_LIST } from 'constants/index'
import withPromise from 'helpers/withPromise'

function LicenseeSelect({
  licenseeFetchList,
  selected,
  setSelected,
  onSubmit,
  onClose,
  intl: { formatMessage },
}) {
  const [licensees, setLicensees] = useState([])

  useEffect(() => {
    const psfs = Psfs.create(API_URL_LICENSEE_LIST)
      .createPagination(1, 'all')
      .addFields(['id', 'name'])

    withPromise(licenseeFetchList, { psfs }).then(data => setLicensees(data))
  }, [])

  return (
    <>
      <div className="modal-box-title-holder">
        <div className="modal-box-title">
          {formatMessage({ id: 'copy_title' })}
        </div>
        <div className="modal-box-x-button" onClick={onClose} />
      </div>
      <FormControl fullWidth>
        <InputLabel htmlFor="licensee-list">
          {formatMessage({ id: 'licensees' })}
        </InputLabel>
        <Select
          value={selected}
          onChange={({ target: { value } }) => setSelected(value)}
          inputProps={{
            id: 'licensee-list',
          }}
          MenuProps={{ getContentAnchorEl: null }}>
          {licensees.map(licensee => (
            <MenuItem key={licensee.id} value={licensee.id}>
              {licensee.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <div className="modal-box-footer">
        <Button type="button" className="modal-box-button" onClick={onClose}>
          {formatMessage({ id: 'cancel' })}
        </Button>
        <Button
          disabled={!selected}
          type="button"
          className="primary"
          onClick={() => {
            onSubmit()
            onClose()
          }}>
          {formatMessage({ id: 'copy' })}
        </Button>
      </div>
    </>
  )
}

export default connect(null, {
  licenseeFetchList,
})(injectIntl(LicenseeSelect))
